import { FC } from 'react'

import { useProductReviewFilters } from '../../../../../lib/hooks/useProductReviewFilters'

import { Template } from './Template'

export const FilterSortButton: FC<{ onFilterClick: () => void }> = ({ onFilterClick }) => {
  const { activeFilterCount } = useProductReviewFilters()
  return <Template activeFilterCount={activeFilterCount} onFilterClick={onFilterClick} />
}
